import { Link } from 'react-router-dom';
const NotFound = () => {
    return (
        <>
            <h1 className="" >
                Page Not Found
            </h1>
            <p className="" >
                Sorry, this page does not exist
            </p>
            <span>
                <Link to='/settings' >Go Back To Settings</Link>
            </span>
        </>
    )
}
export default NotFound;
